import React, { useMemo } from "react";
import { FaSpinner } from "react-icons/fa";
import {
  encontrarConteudoPorId,
  idsConteudosRegulares,
} from "./conteudosAgendaUtils";

function formatarHorario(item) {
  const raw = String(item.dt_hora_inicio || "").trim();
  const match = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/.exec(raw);
  const dataHora = match
    ? `${match[3]}/${match[2]}/${match[1]} ${match[4]}:${match[5]}`
    : raw.slice(0, 16).replace("T", " ");
  return dataHora + (item.local ? ` · ${item.local}` : "");
}

export default function PassoConfirmacao({
  convidado,
  selectedIds,
  empresas,
  catalogo,
  isSubmitting,
  onVoltar,
  onConfirmar,
}) {
  const regulares = useMemo(
    () =>
      idsConteudosRegulares(selectedIds, catalogo)
        .map((id) => encontrarConteudoPorId(id, catalogo))
        .filter(Boolean),
    [selectedIds, catalogo],
  );

  return (
    <div className="c26-step-panel">
      <p className="c26-lead">
        Revise o resumo completo das suas escolhas. Ao confirmar, seu link de
        acesso será encerrado e não poderá ser reutilizado.
      </p>

      <section className="cc-confirm-secao">
        <h2 className="cc-confirm-titulo">Seus dados</h2>
        <dl className="cc-confirm-dados">
          <div>
            <dt>Nome</dt>
            <dd>{convidado?.nome || "—"}</dd>
          </div>
          {convidado?.nome_cracha ? (
            <div>
              <dt>Nome no crachá</dt>
              <dd>{convidado.nome_cracha}</dd>
            </div>
          ) : null}
          <div>
            <dt>E-mail</dt>
            <dd>{convidado?.email || "—"}</dd>
          </div>
          <div>
            <dt>Instituição</dt>
            <dd>{convidado?.empresa || "—"}</dd>
          </div>
          <div>
            <dt>Cargo</dt>
            <dd>{convidado?.cargo || "—"}</dd>
          </div>
        </dl>
      </section>

      <section className="cc-confirm-secao">
        <h2 className="cc-confirm-titulo">Conteúdos selecionados</h2>
        {regulares.length === 0 ? (
          <p className="cc-passo-vazio">Nenhum conteúdo selecionado.</p>
        ) : (
          <ul className="cc-confirm-lista">
            {regulares.map((item, index) => (
              <li key={item.id} className="cc-confirm-item">
                <span className="cc-confirm-slot">Conteúdo {index + 1}</span>
                <strong>{item.nome}</strong>
                <span className="cc-confirm-meta">{formatarHorario(item)}</span>
              </li>
            ))}
          </ul>
        )}
      </section>

      <section className="cc-confirm-secao">
        <h2 className="cc-confirm-titulo">Match &amp; Meet</h2>
        {empresas.length === 0 ? (
          <p className="cc-passo-vazio">Nenhuma empresa selecionada.</p>
        ) : (
          <ul className="cc-confirm-lista">
            {empresas.map((empresa, index) => {
              const nome =
                typeof empresa === "string" ? empresa : empresa?.nome;
              const logo =
                typeof empresa === "string" ? null : empresa?.logo || null;
              const key =
                typeof empresa === "string"
                  ? empresa
                  : empresa?.id ?? empresa?.nome ?? index;

              return (
                <li key={key} className="cc-confirm-item cc-confirm-item--empresa">
                  {logo ? (
                    <img
                      src={logo}
                      alt=""
                      className="cc-confirm-logo"
                      loading="lazy"
                    />
                  ) : (
                    <span className="cc-confirm-logo cc-confirm-logo--placeholder" aria-hidden>
                      {(nome || "?").slice(0, 1).toUpperCase()}
                    </span>
                  )}
                  <div className="cc-confirm-empresa-texto">
                    <span className="cc-confirm-slot">Empresa {index + 1}</span>
                    <strong>{nome}</strong>
                  </div>
                </li>
              );
            })}
          </ul>
        )}
      </section>

      <div className="c26-actions">
        <button
          type="button"
          className="c26-btn c26-btn-ghost"
          onClick={onVoltar}
          disabled={isSubmitting}
        >
          Voltar
        </button>
        <button
          type="button"
          className="c26-btn c26-btn-submit"
          onClick={onConfirmar}
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            <>
              <FaSpinner className="fa-spin" aria-hidden /> Salvando…
            </>
          ) : (
            "Confirmar escolhas"
          )}
        </button>
      </div>
    </div>
  );
}
